/**
 *
 * @param scale The  width or height in px of the roller img already there
 * @param size The The number of px on the width or height of the circle measured from the roller img (usually eq to original-4px padding)
 * @param original The number of px on the width or height of the original roller img
 * @returns Size of the loader svg (w or h)
 */
export function sizeFromRoller(scale = 14, size = 13, original = 17) {
  const result = (size * scale) / original;

  return result;
}
